function forms(){
    if ( jQuery( ".form-container" ).length ) {
        var formId = jQuery( ".form-container" ).attr('form-id');
        jQuery(document).trigger('gform_post_render', formId);
    }
}
